<template>
  <v-card data-qa="rolepermissionlist-card-3dss4o">
    <v-card-title class="role-card-title" data-qa="rolepermissionlist-card-title-nfr8n">
      <v-btn v-if="showBackButton" icon small class="mr-4" @click="$emit('back')" data-qa="rolepermissionlist-btn-edf8hi">
        <v-icon data-qa="rolepermissionlist-icon-foxffl">mdi-arrow-left</v-icon>
      </v-btn>
      <span class="role-card-title" data-qa="rolepermissionlist-span-21jfb">{{ $t('roleMaintenance.rolePermissions') }}</span>
      <v-spacer data-qa="rolepermissionlist-spacer-zph5v8"  />
      <v-btn v-if="!expanded" icon @click="expandAll" data-qa="rolepermissionlist-btn-obgjmk">
        <v-tooltip top :color="primaryColor" data-qa="rolepermissionlist-tooltip-avln4i">
          <template v-slot:activator="{ on, attrs }">
            <v-icon large :color="primaryColor" v-bind="attrs" v-on="on" data-qa="rolepermissionlist-icon-w8ewmd">mdi-expand-all-outline</v-icon>
          </template>
          <span data-qa="rolepermissionlist-span-bzkrg">Expand all</span>
        </v-tooltip>
      </v-btn>
      <v-btn v-else icon @click="collapseAll" data-qa="rolepermissionlist-btn-txn9ec">
        <v-tooltip top :color="primaryColor" data-qa="rolepermissionlist-tooltip-mpoei6">
          <template v-slot:activator="{ on, attrs }">
            <v-icon large :color="primaryColor" v-bind="attrs" v-on="on" data-qa="rolepermissionlist-icon-mranad">mdi-collapse-all-outline</v-icon>
          </template>
          <span data-qa="rolepermissionlist-span-bxeh6b">Collapse all</span>
        </v-tooltip>
      </v-btn>
    </v-card-title>
    <v-card-subtitle data-qa="rolepermissionlist-card-subtitle-jf1ry">
      <span class="font-weight-bold" data-qa="rolepermissionlist-span-6dgd4m">{{ roleCode }}</span>
    </v-card-subtitle>
    <v-card-text data-qa="rolepermissionlist-card-text-wbmpxk">
      <v-expansion-panels v-model="panels" multiple data-qa="rolepermissionlist-expansion-panels-mgepse">
        <v-expansion-panel
          v-for="(group, index) in groupedPerCategory"
          :key="index"
          class="thin-border"
         :data-qa="`rolepermissionlist-expansion-panel-hynwyj-${index}`">
          <v-expansion-panel-header data-qa="rolepermissionlist-expansion-panel-header-lduddlb">{{ group.category }}</v-expansion-panel-header>
          <v-expansion-panel-content data-qa="rolepermissionlist-expansion-panel-content-v5f4np">
            <v-list data-qa="rolepermissionlist-list-t6sbrx">
              <v-list-item v-for="(item, idx) in group.items" :key="idx" :data-qa="`rolepermissionlist-list-item-b4hdj9-${idx}`">
                <v-list-item-content data-qa="rolepermissionlist-list-item-content-i5h9tg">
                  <v-list-item-title class="role-wrap-text" data-qa="rolepermissionlist-list-item-title-gme4a">{{ item.permissionName }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action data-qa="rolepermissionlist-list-item-action-3y0qr">
                  <v-icon v-if="item.enabled" color="green" data-qa="rolepermissionlist-icon-9e71s">mdi-check</v-icon>
                  <v-icon v-else color="red" data-qa="rolepermissionlist-icon-vvgp9f">mdi-close</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
import '@/styles/pages/roles/roles.scss'

import commonService from '../../service/commonService'

export default {
  name: 'RolePermissionList',
  props: {
    corporateCode: {
      type: String,
      required: true
    },
    roleCode: {
      type: String,
      required: true
    },
    showBackButton: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      panels: [],
      permissions: [],
      expanded: false
    }
  },
  watch: {
    corporateCode: 'fetchPermissions',
    roleCode: 'fetchPermissions'
  },
  async created () {
    await this.fetchPermissions()
    this.expandAll()
  },
  mounted () {
    this.expandAll()
  },
  methods: {
    async fetchPermissions () {
      try {
        this.permissions = (await commonService.getSmeRole(this.corporateCode, this.roleCode))?.permDetail ?? []
      } catch (error) {
        console.error('Error fetching SME role permissions', error)
        this.permissions = []
      }
    },
    expandAll () {
      this.panels = this.groupedPerCategory.map((_, i) => i)
      this.expanded = true
    },
    collapseAll () {
      this.panels = []
      this.expanded = false
    }
  },
  computed: {
    groupedPerCategory () {
      if (!this.permissions.length) return []

      const groups = this.permissions.reduce((acc, item) => {
        const group = acc.find(g => g.category === item.permCategoryName)
        const mapItem = {
          permissionName: item.permissionName,
          enabled: item.assignedFlag === 'Y'
        }
        if (group) {
          group.items.push(mapItem)
        } else {
          acc.push({ category: item.permCategoryName, items: [mapItem] })
        }
        return acc
      }, [])
      return groups
    }
  }
}

</script>
